module.exports = __webpack_public_path__ + "crm_static/img/img_ooops@2x.d1d9e447.png";